import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isPersonalizedChurnModalOpen: false,
}

const churnModalsSlice = createSlice({
  name: 'churnModals',
  initialState,
  reducers: {
    startChurnModalFlow: (state) => {
      state.isPersonalizedChurnModalOpen = true
    },
    resetChurnModals: (state) => {
      state.isPersonalizedChurnModalOpen = false
    }
  }
})

export const { reducer,
  actions: {
    startChurnModalFlow,
    resetChurnModals
  } } = churnModalsSlice
